export class LoadingPopup {
    static show() {
        $('html').addClass('_open_bus_popup');
        $('.bus_overlay').addClass('_active _wait');
        $('#avia_popup_search').addClass('_active');
    }

    static hide() {
        $( 'html' ).removeClass( '_open_bus_popup' );
        $( '.bus_overlay' ).removeClass( '_active _wait' );
        $( '.bus_popup' ).removeClass( '_active' );
        $( '.popup_places' ).removeClass( '_active' );
    }
}